// extracted by mini-css-extract-plugin
module.exports = {"empty":"Empty_empty__2lAnd","empty__title":"Empty_empty__title__2chDh","empty__text":"Empty_empty__text__2m8Ya"};